export default __webpack_public_path__ + "static/media/jcb.2eb070d4.svg";